// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { IconWrapper } from "@insite/mobius/Icon";
import { productAvailabilityStyles } from "@pace/Overrides/Components/ProductAvailability";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productAvailabilityStyles.inventoryMessage = {
    css: css`
        background: none;
        padding: 0;
        font-size: 12px;
        line-height: 13px;
        font-weight: ${fontConfig.weight.bold};
        display: flex;
        gap: 4px;
        ${IconWrapper} {
            margin: 0;
            width: 12px;
            height: 13px;
            opacity: 0.6;
        }
    `,
};
productAvailabilityStyles.container = {
    gap: 4,
};

productAvailabilityStyles.messageGridItem = {
    width: [6, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};
productAvailabilityStyles.actionsGridItem = {
    width: [6, 6, 6, 6, 6],
};

productAvailabilityStyles.buttonsContainer = {
    width: 12,
    css: css`
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        padding: 0;
    `,
};

productAvailabilityStyles.availabilityByWarehouseLink = {
    typographyProps: {
        size: 10,
        weight: fontConfig.weight.bold,
        lineHeight: "11px",
        css: css`
            &&&& {
                color: ${color("common.ui14")};
                text-align: right;
                text-wrap: nowrap;
                &:hover {
                    color: ${color("common.ui17")};
                }
            }
        `,
    },
    mergeCss: true,
};

productAvailabilityStyles.availabilityMessagesResult = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex: 1;
    `,
};

productAvailabilityStyles.qtyValue = {
    weight: "normal",
};
